import React from 'react';

export const EmptyStoreMessage = () => {
  return <div className="store__message" />;
};
